function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_404",
  "data-name": "Group 404",
  transform: "translate(-226.397 -1710.848)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1381",
  "data-name": "Path 1381",
  d: "M3683.308,164.436a169.249,169.249,0,1,1-169.25,169.249S3498.063,153.555,3757.892,66.9Z",
  transform: "translate(-3281.382 1693.042)",
  fill: "none",
  stroke: "#261f1c",
  strokeWidth: 12
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1383",
  "data-name": "Path 1383",
  d: "M3621.953,234.807,3790.979,69l-113.951.405S3467.877,278.44,3461.79,286.048c-28.939,36.175-38.407,70.6-38.407,102.848a159.042,159.042,0,1,0,198.57-154.09Z",
  transform: "translate(-2800.479 1647.9)",
  fill: "none",
  stroke: "#261f1c",
  strokeWidth: 12
}));

var SvgDoubleQuoteBackground = function SvgDoubleQuoteBackground(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 778.841,
    height: 491.129,
    viewBox: "0 0 778.841 491.129",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleQuoteBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/double-quote-background.0f268e48.svg";
export { ForwardRef as ReactComponent };